import { DeleteOutlined, LockOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import DisableIcon from 'assets/images/svg/DisableIcon';
import EnableIcon from 'assets/images/svg/EnableIcon';
import React, { useState } from 'react';
import { Notification } from 'zComponents/atoms';
import { AddPeopleToTeamsModal, DeletePeopleModal, DisablePeopleModal, EnablePeopleModal } from 'zComponents/molecules';
import { Button, Divider, Dropdown, Flex } from 'zui/Antd';

const ManagePeopleDropdown = ({ personIDs = [], setSelectedPersonIDs }) => {
	// ✅ Hooks
	const {
		token: {
			colorBgContainer,
			colorPrimary,
			colorIcon,
			boxShadow,
			borderRadiusLG,
			paddingSM,
			fontSizeLG,
			colorError
		}
	} = theme.useToken();

	// ✅ Modal States
	const [openDropdown, setOpenDropdown] = useState(false);

	// ✅ Helper to pluralize label
	const pluralizeLabel = (label) =>
		personIDs.length > 1 ? label.replace('Person', 'People').replace('Profile', 'Profiles') : label;

	const items = [
		{
			key: 'Add Person to Team',
			label: (
				<AddPeopleToTeamsModal personIDs={personIDs} setSelectedPersonIDs={setSelectedPersonIDs}>
					<Button
						type='text'
						icon={<UsergroupAddOutlined style={{ color: colorIcon, fontSize: fontSizeLG }} />}
						block
						style={{
							justifyContent: 'flex-start'
						}}
					>
						{pluralizeLabel('Add Person to Team')}
					</Button>
				</AddPeopleToTeamsModal>
			)
		},
		{
			key: '',
			label: <Divider />
		},
		{
			key: 'Revoke All Access',
			label: (
				<Button
					type='text'
					icon={<LockOutlined style={{ color: colorIcon, fontSize: fontSizeLG }} />}
					block
					style={{
						justifyContent: 'flex-start'
					}}
					onClick={() => Notification('info', 'This feature is not available yet.')}
				>
					Revoke All Access (WIA)
				</Button>
			)
		},
		{
			key: 'Enable Profile',
			label: (
				<EnablePeopleModal personIDs={personIDs}>
					<Button
						type='text'
						icon={<EnableIcon width={fontSizeLG} height={fontSizeLG} fillOpacity={0.45} />}
						block
						style={{
							justifyContent: 'flex-start'
						}}
					>
						{pluralizeLabel('Enable Profile')}
					</Button>
				</EnablePeopleModal>
			)
		},
		{
			key: 'Disable Profile',
			label: (
				<DisablePeopleModal personIDs={personIDs}>
					<Button
						type='text'
						icon={<DisableIcon width={fontSizeLG} height={fontSizeLG} fillOpacity={0.45} />}
						block
						style={{
							justifyContent: 'flex-start'
						}}
					>
						{pluralizeLabel('Disable Profile')}
					</Button>
				</DisablePeopleModal>
			)
		},
		{
			key: 'Delete Profile',
			label: (
				<DeletePeopleModal personIDs={personIDs}>
					<Button
						type='text'
						danger
						icon={
							<DeleteOutlined
								style={{
									color: colorError,
									fontSize: fontSizeLG
								}}
							/>
						}
						block
						style={{
							justifyContent: 'flex-start'
						}}
					>
						{pluralizeLabel('Delete Profile')}
					</Button>
				</DeletePeopleModal>
			)
		}
	];

	return (
		<Dropdown
			openClassName='dropdown-open'
			trigger={['click']}
			placement='bottomRight'
			open={openDropdown}
			onOpenChange={(visible) => setOpenDropdown(visible)}
			dropdownRender={() => (
				<Flex
					style={{
						backgroundColor: colorBgContainer,
						borderRadius: borderRadiusLG,
						width: 240,
						boxShadow: boxShadow,
						padding: paddingSM
					}}
					vertical
					gap={paddingSM}
				>
					{items.map((item) => item.label)}
				</Flex>
			)}
		>
			<Button
				type='default'
				style={{
					borderColor: colorPrimary,
					color: colorPrimary
				}}
			>
				{pluralizeLabel('Manage Person')}
			</Button>
		</Dropdown>
	);
};

export default ManagePeopleDropdown;
